// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.GlobalError_row__J90ca {
  width: 100%;
}

.GlobalError_container__nncr- {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
  box-sizing: border-box;
}

.GlobalError_alert__urdlE {
  width: 100%;
  box-sizing: border-box;
  padding: 24px;
  margin: 0 0 20px 0;
  border-radius: 6px;
  color: #ffffff;
  display: flex;
  justify-content: center;
  background: #666;
}

.GlobalError_successBg__JfuFh {
  background: #666;
}

.GlobalError_innerRow__LRQEa {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 16px;
}

.GlobalError_iconCol__YRfGq,
.GlobalError_iconColSmall__6cElD {
  flex: 0 0 80px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.GlobalError_iconColSmall__6cElD {
  flex: 0 0 65px;
}

.GlobalError_icon__CwlX4 {
  display: inline-block;
  width: 65px;
  height: auto;
}

.GlobalError_textCol__CukC\\+ {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.GlobalError_titleRow__Ut7ib,
.GlobalError_messageRow__0HLgP {
  width: 100%;
}

.GlobalError_titleCol__2CslR,
.GlobalError_messageCol__Bak\\+5 {
  width: 100%;
}

.GlobalError_title__cnCss {
  font-size: 26px;
  line-height: 1.2;
  font-weight: 600;
  display: inline-block;
}

.GlobalError_message__8N\\+S0 {
  font-size: 20px;
  line-height: 1.4;
  display: inline-block;
}

@media (max-width: 767px) {
  .GlobalError_alert__urdlE {
    word-break: break-word;
    padding: 5rem 1rem 2rem !important;
    margin: 0 !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/GlobalError.module.scss"],"names":[],"mappings":"AAKA;EACI,WAAA;AAJJ;;AAOA;EACI,iBARQ;EASR,cAAA;EACA,eAAA;EACA,sBAAA;AAJJ;;AAOA;EACI,WAAA;EACA,sBAAA;EACA,aAAA;EACA,kBAAA;EACA,kBAAA;EACA,cArBS;EAsBT,aAAA;EACA,uBAAA;EACA,gBAzBM;AAqBV;;AAQA;EACI,gBA9BM;AAyBV;;AAQA;EACI,aAAA;EACA,mBAAA;EACA,WAAA;EACA,SAAA;AALJ;;AAQA;;EAEI,cAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AALJ;;AAQA;EACI,cAAA;AALJ;;AAQA;EACI,qBAAA;EACA,WAAA;EACA,YAAA;AALJ;;AASA;EACI,cAAA;EACA,aAAA;EACA,sBAAA;EACA,QAAA;AANJ;;AAUA;;EAEI,WAAA;AAPJ;;AAUA;;EAEI,WAAA;AAPJ;;AAUA;EACI,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,qBAAA;AAPJ;;AAUA;EACI,eAAA;EACA,gBAAA;EACA,qBAAA;AAPJ;;AAUA;EACI;IACI,sBAAA;IACA,kCAAA;IACA,oBAAA;EAPN;AACF","sourcesContent":["$dark-bg: #666;\n$text-white: #ffffff;\n$max-width: 1200px;\n$gutter: 16px;\n\n.row {\n    width: 100%;\n}\n\n.container {\n    max-width: $max-width;\n    margin: 0 auto;\n    padding: 0 $gutter;\n    box-sizing: border-box;\n}\n\n.alert {\n    width: 100%;\n    box-sizing: border-box;\n    padding: 24px;\n    margin: 0 0 20px 0;\n    border-radius: 6px;\n    color: $text-white;\n    display: flex;\n    justify-content: center;\n    background: $dark-bg;\n}\n\n\n.successBg {\n    background: $dark-bg;\n}\n\n.innerRow {\n    display: flex;\n    align-items: center;\n    width: 100%;\n    gap: 16px;\n}\n\n.iconCol,\n.iconColSmall {\n    flex: 0 0 80px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.iconColSmall {\n    flex: 0 0 65px;\n}\n\n.icon {\n    display: inline-block;\n    width: 65px;\n    height: auto;\n}\n\n\n.textCol {\n    flex: 1 1 auto;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n\n.titleRow,\n.messageRow {\n    width: 100%;\n}\n\n.titleCol,\n.messageCol {\n    width: 100%;\n}\n\n.title {\n    font-size: 26px;\n    line-height: 1.2;\n    font-weight: 600;\n    display: inline-block;\n}\n\n.message {\n    font-size: 20px;\n    line-height: 1.4;\n    display: inline-block;\n}\n\n@media (max-width: 767px) {\n    .alert {\n        word-break: break-word;\n        padding: 5rem 1rem 2rem !important;\n        margin: 0 !important\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"row": `GlobalError_row__J90ca`,
	"container": `GlobalError_container__nncr-`,
	"alert": `GlobalError_alert__urdlE`,
	"successBg": `GlobalError_successBg__JfuFh`,
	"innerRow": `GlobalError_innerRow__LRQEa`,
	"iconCol": `GlobalError_iconCol__YRfGq`,
	"iconColSmall": `GlobalError_iconColSmall__6cElD`,
	"icon": `GlobalError_icon__CwlX4`,
	"textCol": `GlobalError_textCol__CukC+`,
	"titleRow": `GlobalError_titleRow__Ut7ib`,
	"messageRow": `GlobalError_messageRow__0HLgP`,
	"titleCol": `GlobalError_titleCol__2CslR`,
	"messageCol": `GlobalError_messageCol__Bak+5`,
	"title": `GlobalError_title__cnCss`,
	"message": `GlobalError_message__8N+S0`
};
export default ___CSS_LOADER_EXPORT___;
